<template>
	<div class="shopcars">
		<div class="icon df cf wao hao" @click="tapIcon" v-if="!$websitecheck"><em><i v-if="$store.state.shopcarNum>0">{{$store.state.shopcarNum}}</i></em>购<br>物<br>车</div>
		<div class="layer" v-show="isShowBox" @click="tapIcon"></div>
		<div class="box" :class="{ show: isShowBox }">
			<div class="title df hao jcb">购物车 ({{list.length}})<span @click="tapUpdate">管理</span></div>
			<div class="list">
				<div class="li df" v-for="(v,i) in list">
					<div class="choose" :class="{ cur: choose.indexOf(v.cid)>=0 }" @click="tapChoose(v.cid)"></div>
					<img :src="v.img" alt="">
					<div class="flex-o">
						<div class="cap ov-d">{{v.name}}</div>
						<div class="txt">等级 : {{v.level}}</div>
						<div class="txt">规格 : {{v.spec}}</div>
						<div class="df hao jcb">
							<div class="num df">
								<em @click="tapSub(v)"></em>
								<input type="number" class="flex-o" v-model="v.num" @blur="numBlur(v)">
								<em @click="tapAdd(v)"></em>
							</div>
							<div class="price">¥<em>{{v.price}}</em><span>{{v.uom}}</span></div>
						</div>
					</div>
				</div>
			</div>
			<div class="tool df hao jcb" v-if="!isShowManage">
				<!-- 共计{{$store.state.shopcarAllNum}}件 -->
				已选{{choose.length}}件
				<!-- <div>总计<span>¥<em>{{getPricePay()}}</em></span></div> -->
				<div>总计<span>¥<em>{{getPricePay(true)}}</em></span></div>
			</div>
			<div class="df" v-if="isShowManage">
				<div class="btn flex gray" @click="tapUpdate">取消</div>
				<div class="btn flex" @click="tapRemove">删除</div>
			</div>
			<div class="df" v-else>
				<div class="btn flex gray" @click="tapMore">{{list.length==choose.length&&list.length>0?'取消全选':'全选'}}</div>
				<div class="btn flex" @click="tapSubmit">下单</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'shopcars',
	props: {},
	data () {
		return {
			isShowBox: false,
			isShowManage: false,
			choose: [],
			list: [],
		}
	},
	methods: {
		showShopCar(){
			this.isShowBox = true
			this.choose = []
			this.getData()
		},
		getPricePay(onlyChoose){
			let price = 0
			this.list.forEach(v=>{
				if((onlyChoose==true&&this.choose.indexOf(v.cid)>=0)||onlyChoose!=true){
					price += Number(v.priceAll)
				}
			})
			return price.toFixed(2)
		},
		tapIcon(){
			this.isShowBox = !this.isShowBox
			this.choose = []
			this.getData()
		},
		getData(){
			this.$ajax.getShopcar().then(r=>{
				this.$store.commit('updateShopcar',{
					count: r.goods_list.length,
					count2: r.order_total_num,
				})
				let arr = []
				r.goods_list.forEach(v=>{
					arr.push(this.getModel(v))
				})
				this.list = arr
        console.log(this.list);

				if(this.list.length==0){
					this.isShowManage = false
					this.choose = []
				}
			})
		},
		getModel(data){
			return {
				cid: data.cart_id, // 购物车id
				id: data.id,
				sid: data.goods_sku_id, // 规格id
				name: data.name,
				level: data.zmm_level,
				spec: data.spec_name,
				img: data.main_images,
				num: Number(data.total_num),
				uom: data.unit_name,
				price: Number(data.price).toFixed(2),
				priceAll: Number(data.total_price).toFixed(2),
			}
		},
		tapUpdate(){
			if(this.isShowManage){
				this.isShowManage = false
			}else{
				this.isShowManage = true
			}
			this.choose = []
		},
		tapChoose(cid){
			if(this.choose.indexOf(cid)>=0){
				this.choose.splice(this.choose.indexOf(cid),1)
			}else{
				this.choose.push(cid)
			}
		},
		tapSub(data){
			this.$ajax.subShopcarNum({
				goods_id: data.id,
				goods_sku_id: data.sid,
				goods_num: this.$api.getMathMin(data.num),
			}).then(r=>{
				// data.num --
				this.getData()
			})
		},
		tapAdd(data){
			this.$ajax.addShopcarNum({
				goods_id: data.id,
				goods_sku_id: data.sid,
				goods_num: this.$api.getMathMin(data.num),
			}).then(r=>{
				// data.num ++
				this.getData()
			})
		},
		numBlur(data){
			if(data.num<=0){
				data.num = 1
			}

			this.$ajax.updateShopcarNum({
				goods_id: data.id,
				goods_sku_id: data.sid,
				goods_num: Number(data.num),
			}).then(r=>{
				this.getData()
			}).catch(r=>{
				this.getData()
			})
		},
		tapRemove(){
			if(this.choose.length==0){
				this.$alert({
					title: '请选择要删除的商品',
				}).then(()=>{})
				return
			}

			this.$ajax.deleteShopcar({
				cart_ids: this.choose.toString(),
			}).then(r=>{
				this.choose = []
				this.getData()
			})
		},
		tapSubmit(){
			if(this.list.length==0){
				this.$alert({
					title: '请先将要下单的商品加入购物车',
				}).then(()=>{})
				return
			}else if(this.choose.length==0){
				this.$alert({
					title: '请选择要下单的商品',
				}).then(()=>{})
				return
			}

			this.isShowBox = false
			this.$api.toPage('payment',{
				cids: this.choose.toString(),
			});
		},
		tapMore(){
			if(this.choose.length==this.list.length){
				this.choose = []
				return
			}
			let arr = []
			this.list.forEach(v=>{
				arr.push(v.cid)
			})
			this.choose = arr
		},
	},
}
</script>

<style lang="less" scoped>
	.shopcars{
		.icon{
			cursor: pointer;
			width: 60px;
			height: 150px;
			background: #FFE8EA;
			box-shadow: 0px 5px 20px 0px rgba(40,84,172,0.12);
			border-radius: 8px 0 0 8px;
			border: 1px solid #E73363;
			border-right: 0;
			position: fixed;
			z-index: 1005;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: #E73363;
			line-height: 21px;
			em{
				width: 32px;
				height: 32px;
				background: url(../../assets/img/shopcar3.png) center center / 100% auto no-repeat;
				margin-bottom: 4px;
				position: relative;
			}
			i{
				min-width: 18px;
				background: #E73363;
				border-radius: 50px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 600;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 18px;
				text-align: center;
				position: absolute;
				right: -9px;
				top: -4px;
				padding: 0 4px;
			}
		}
		.layer{
			position: fixed;
			z-index: 1007;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
		}
		.box{
			width: 370px;
			border: 1px solid #e73363;
			position: fixed;
			z-index: 1008;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
			background: #fff;
			transition: all 0.2s ease-in-out;
			pointer-events: none;
			margin-top: 10px;
			opacity: 0;
			&.show{
				margin-top: 0;
				pointer-events: auto;
				opacity: 1;
			}
		}
		.title{
			padding: 16px 20px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 20px;
			color: #E73363;
			line-height: 23px;
			span{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #4C4C4C;
				line-height: 19px;
				background: url(../../assets/img/arrow3.png) right center / 20px auto no-repeat;
				padding-right: 32px;
				cursor: pointer;
			}
		}
		.list{
			min-height: 320px;
			max-height: 480px;
			overflow-y: auto;
			&:empty{
				background: url(../../assets/img/empty.png) center center / 164px auto no-repeat;
			}
		}
		.li{
			padding: 16px 20px;
			.choose{
				width: 48px;
				margin-left: -16px;
				cursor: pointer;
				background: url(../../assets/img/choose3.png) center center / 16px auto no-repeat;
				&.cur{
					background-image: url(../../assets/img/choose4.png);
				}
			}
			img{
				width: 80px;
				height: 80px;
				object-fit: cover;
				margin-right: 16px;
			}
			.cap{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #000000;
				line-height: 16px;
				height: 16px;
			}
			.txt{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #888;
				line-height: 15px;
				height: 15px;
				margin-top: 4px;
				margin-bottom: 3px;
			}
			.num{
				// 改改
				border-radius: 2px; /* 添加圆角 */
				box-sizing: border-box; /* 确保边框宽度不会影响元素的总宽度 */
				// width: 66px;
				height: 20px;
				border: 0.5px solid #B0B0B0; /* 减少边框宽度 */
				overflow: hidden;
				margin-right: 10px;
				input{
					display: inline-block;
					width: 30px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #000000;
					line-height: 18px;
					height: 18px;
					border: 0;
					// text-align: center;
				}
				em{
					cursor: pointer;
					width: 18px;
					height: 18px;
					&:first-child{
						border-right: 1px solid #B0B0B0;
						background: url(../../assets/img/sub.png) center center / 100% auto no-repeat;
					}
					&:last-child{
						border-left: 1px solid #B0B0B0;
						background: url(../../assets/img/add.png) center center / 100% auto no-repeat;
					}
				}
			}
			.price{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 10px;
				color: #E73363;
				line-height: 23px;
				em{
					font-size: 20px;
				}
				span{
					font-size: 14px;
					color: #666666;
					margin-left: 4px;
				}
			}
		}
		.tool{
			height: 46px;
			padding: 0 20px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #000000;
			line-height: 16px;
			span{
				margin-left: 8px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #E73363;
				line-height: 28px;
				em{
					font-size: 24px;
				}
			}
		}
		.btn{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 50px;
			text-align: center;
			background: #e73363;
			&.gray{
				background: #f0f0f0;
				color: #666666;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/shopcars/shopcars.vue